import styled, { css } from 'styled-components';

import Button from '@polyai/ui/components/atoms/Button';
import { ButtonContentContainer } from '@polyai/ui/components/atoms/Button/Button.styled';
import { PopoverContent } from '@polyai/ui/components/atoms/Popover';
import themeColors from '@polyai/ui/styles/config/colors';
import themeSpacing from '@polyai/ui/styles/config/spacing';
import text from '@polyai/ui/styles/config/text';

export const FadeButton = styled(Button)<{ $isExpanded: boolean }>`
  width: 100%;
  background-color: ${themeColors.backgroundPrimary};
  border-radius: 0;

  svg {
    flex-shrink: 0;
  }

  .buttonEndAdornment,
  .buttonLabel {
    overflow: hidden;
    transition: width 0.2s ease-in-out, min-width 0.2s ease-in-out, margin 0.2s ease-in-out, opacity 0.2s ease-in-out;

    ${({ $isExpanded }) =>
      $isExpanded
        ? css``
        : css`
            width: 0;
            min-width: auto;
            margin: 0;
            opacity: 0;
          `};
  }

  .buttonLabel {
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .buttonEndAdornment {
    display: inline-flex;

    ${({ $isExpanded }) =>
      $isExpanded &&
      css`
        margin-left: auto;
      `}
  }

  ${ButtonContentContainer} {
    justify-content: flex-start;
    transition: gap 0.2s ease-in-out, justify-content 0.2s ease-in-out;

    ${({ $isExpanded }) =>
      !$isExpanded &&
      css`
        gap: 0;
        justify-content: center;
      `}
  }

  ${({ $isExpanded }) =>
    $isExpanded
      ? css`
          padding-left: ${themeSpacing.sm1};
        `
      : css`
          padding-right: ${themeSpacing.xs2};
          padding-left: ${themeSpacing.xs2};
        `}

  &:hover {
    background-color: ${themeColors.backgroundPrimaryHover};
  }
`;

export const UserMenuPopoverContent = styled(PopoverContent)`
  overflow: clip;
  width: 220px;
  border-color: ${themeColors.borderStrongInverse};
  border-radius: ${themeSpacing.radiusMedium};
`;

export const PopoverRow = styled.div`
  cursor: pointer;

  position: relative;

  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  height: ${themeSpacing.md1};
  padding: ${themeSpacing.xs2} ${themeSpacing.sm1};

  text-decoration: none;

  background: ${themeColors.backgroundInverse};
  border: none;

  &:hover {
    background: ${themeColors.backgroundAccentInverse};
  }

  &:focus-visible {
    outline: 2px solid ${themeColors.borderFocus};
    outline-offset: -2px;
  }
`;

export const ThemeRow = styled.div`
  position: relative;

  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  height: ${themeSpacing.md1};
  padding: ${themeSpacing.xs2} ${themeSpacing.sm1};

  background: ${themeColors.backgroundInverse};
`;

export const RowLabel = styled.span`
  overflow: hidden;

  font-family: 'Proxima Nova', sans-serif;
  font-size: ${text.size.body.regular};
  font-weight: ${text.weight.semibold};
  line-height: 1.2;
  color: ${themeColors.textSecondaryInverse};
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RowDivider = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;

  height: 1px;

  background: ${themeColors.borderSubtleInverse};
`;
